import styled from "styled-components";
import {
  recieveMoney_desktop,
  recieveMoney_tab,
  BiggerBoxImage,
  recieveMoney_mobile,
} from "../../../../public/assets";

export const Left = styled.div`
  /* width: 50%; */
  @media screen and (max-width: 430px) {
    /* width: 100%;
    display: flex;
    align-items: center;
    justify-content: center; */
    /* border: 2px solid red; */
  }
`;

export const Biggest = styled.div`
  width: 511px;
  /* width:50%; */
  height: 473px;
  flex-shrink: 0;
  border-radius: 20px;
  background: rgba(94, 94, 94, 0.1);
  box-shadow: 0px -3.788px 60.318px 4.735px rgba(192, 193, 207, 0.38);
  margin-left: 50px;
  box-sizing: border-box;
  /* border: 2px solid blue; */
  /* position: relative; */

  @media screen and (max-width: 2560px) {
    width: 611px;
    height: 573px;
  }

  @media screen and (max-width: 1440px) {
    width: 511px;
    height: 473px;
  }

  @media screen and (max-width: 1024px) {
    width: 511px;
    height: 473px;
    /* top: 60px
left: 70px */
  }
  @media screen and (max-width: 768px) {
    width: 511px;
    height: 473px;
    /* top: 60px
left: 70px */
  }

  @media screen and (max-width: 430px) {
    /* width: 270px; */
    width: 270px;
    height: 289px;
    background: var(--General-Background, #f7f7f7);
    padding-left: 5px;
    margin-left: 0px;
    /* margin-right: 300px; */
  }
  @media screen and (max-width: 375px) {
    width: 270px;
    height: 289px;
    background: var(--General-Background, #f7f7f7);
    padding-left: 5px;
    margin-right: 0px;
    margin-left: 50px;
  }
`;

export const Bigger = styled.div`
  width: 492px;
  height: 414px;
  flex-shrink: 0;
  border-radius: 20px;
  background-image: url("/assets/Rectangle24950.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
  /* border: 2px solid blue; */
  z-index: 1;
  top: 25px;
  right: 55px;

  @media screen and (max-width: 2560px) {
    width: 592px;
    height: 514px;
  }

  @media screen and (max-width: 1920px) {
    /* width: 492px;
    height: 411px; */
    top: 25px;
    right: 50px;
  }

  @media screen and (max-width: 1440px) {
    width: 492px;
    height: 414px;
  }
  @media screen and (max-width: 1440px) {
    top: 25px;
    right: 55px;
  }
  @media screen and (max-width: 1024px) {
    width: 492px;
    height: 411px;
    top: 25px;
    right: 60px;
  }
  @media screen and (max-width: 768px) {
    width: 492px;
    height: 411px;
    top: 25px;
    right: 60px;
  }

  @media screen and (max-width: 430px) {
    width: 282px;
    height: 237px;
    top: 25px;
    right: 30px;
  }
  @media screen and (max-width: 375px) {
    width: 282px;
    height: 237px;
    top: 25px;
    right: 30px;
  }
`;

export const Big = styled.div`
  width: 274px;
  height: 181.057px;
  position: relative;
  flex-shrink: 0;
  border-radius: 24.141px;
  /* background: var(--General-White, #fff); */
  box-shadow: 0px 4.828px 73.63px 0px rgba(125, 125, 125, 0.37);
  /* border: 2px solid black; */
  background-image: url("/assets/Recieve_money_Desktop.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  top: 200px;
  right: 50px;

  @media screen and (max-width: 2560px) {
    width: 374px;
    height: 281.057px;
    /* background-image: url("/assets/Recieve_money_Desktop.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center; */
  }

  @media screen and (max-width: 1920px) {
    /* width: 274px;
    height: 181.06px; */
    top: 200px;
    right: 50px;
  }
  @media screen and (max-width: 1440px) {
    width: 274px;
    height: 181.057px;
    top: 200px;
    right: 50px;
  }
  @media screen and (max-width: 1024px) {
    width: 274px;
    height: 181.06px;
    background-image: url("/assets/Recieve_money_Desktop.png");
    /* background-size: cover; */
    background-repeat: no-repeat;
    background-position: center;
    top: 200px;
    right: 40px;
  }
  @media screen and (max-width: 768px) {
    width: 274px;
    height: 181.06px;
    top: 200px;
    right: 40px;
  }

  @media screen and (max-width: 430px) {
    width: 192px;
    height: 135px;
    top: 80px;
    right: 20px;
  }
  @media screen and (max-width: 375px) {
    width: 192px;
    height: 135px;
    top: 80px;
    right: 20px;
  }
  @media screen and (max-width: 320px) {
    width: 192px;
    height: 135px;
    top: 80px;
    right: 20px;
  }
`;
